import React from 'react'

export default function ReferIcon({ ...rest }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M25.3327 28V20M21.3327 24H29.3327M15.9993 20H10.666C8.18099 20 6.93848 20 5.95837 20.406C4.65155 20.9473 3.61329 21.9855 3.07199 23.2924C2.66602 24.2725 2.66602 25.515 2.66602 28M20.666 4.38768C22.6206 5.17886 23.9993 7.09508 23.9993 9.33333C23.9993 11.5716 22.6206 13.4878 20.666 14.279M17.9993 9.33333C17.9993 12.2789 15.6115 14.6667 12.666 14.6667C9.7205 14.6667 7.33268 12.2789 7.33268 9.33333C7.33268 6.38781 9.7205 4 12.666 4C15.6115 4 17.9993 6.38781 17.9993 9.33333Z" 
        stroke="#2A2E44" 
        strokeWidth="2.67" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
      />
    </svg>
  )
}